import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DynamicFormIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dynamic_form"}/>
}
